import { render, staticRenderFns } from "./Cennik.vue?vue&type=template&id=fc60031a&scoped=true&"
import script from "./Cennik.vue?vue&type=script&lang=js&"
export * from "./Cennik.vue?vue&type=script&lang=js&"
import style0 from "./Cennik.vue?vue&type=style&index=0&id=fc60031a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc60031a",
  null
  
)

export default component.exports